import React, { PureComponent } from 'react';
import PT from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import FiltersHeader from '../../components/FiltersHeader';
import ButtonMenu from '../../components/FilterComponents/ButtonMenu';
import PrimaryDropdown from '../../components/FilterComponents/PrimaryDropdown';
import DataTable from '../../components/DataTable';
import FilterToggle from '../../components/FilterComponents/FilterToggle';
import TableControls from '../../components/TableControls';
import { selectControlsState } from '../../../store/reducers/tableControls';
import { positionToTitle } from '../../../lib/lookups';
import { DropdownOptionsType, FilterMenuOptionsType } from '../../../lib/proptypes/semantic';
import { selectWeeksWithPreSeasonForDropdown,selectWeeksNewWithPreSeasonForDropdown } from '../../../store/reducers/season';
import {
  selectPositionsForFilterMenu,
  getColGroups,
} from '../../../store/reducers/positions';
import { clearSelectedPlayers } from '../../../store/reducers/tableControls';
import ColGroupsTypes from '../../../lib/proptypes/colGroups';
import { goToView } from '../../routes.global';
import { DataPT } from '../../components/DataTable/DataTable.proptypes';
import {
  PROJECTIONS_VIEW,
  selectProjectionsState,
  PROJ_PRESEASON_POSITION_STATS_MAP_KEY,
  PROJ_WEEKLY_POSITION_STATS_MAP_KEY,
} from './module/projections';
import classes from './PlayerProjections.css';
import {
  selectToolDescriptionsState,
} from '../../../store/reducers/toolDescriptions';
import { ToolDescription } from '../../components/ToolDescriptions/ToolDescriptions';
import { gciPageView } from '../../../lib/analytics';

// const log = debug('huddle:app:views:playerProjections');
const pageTitle = 'Player Rankings & Projections';

const mapStateToProps = state => {
  const {
    position,
    year,
    formulaId,
    week,
    ranking,
    lastUpdatedAt,
    hasLoaded,
  } = selectProjectionsState(state);
  const {
    toolDescriptions,
    toolsLoaded,
  } = selectToolDescriptionsState(state);

  const loggedIn = state.auth.loggedIn;

  const key = (week === 0) ?
    PROJ_PRESEASON_POSITION_STATS_MAP_KEY :
    PROJ_WEEKLY_POSITION_STATS_MAP_KEY;
  var mapfunc = selectWeeksWithPreSeasonForDropdown;
  if ( year >= 2021 ) {
    mapfunc = selectWeeksNewWithPreSeasonForDropdown;
  }

  return {
    hasLoaded,
    loggedIn,
    positions: selectPositionsForFilterMenu(state, 'projections'),
    positionsCombined: selectPositionsForFilterMenu(state, 'projectionsCombined'),
    selectedPosition: position,
    selectedYear: year,
    selectedWeek: week,
    selectedProfile: formulaId,
    toolDescriptions,
    toolsLoaded,
    lastUpdatedAt,
    collapsed: selectControlsState(state).collapsed,
    ...hasLoaded && {
      weeks: mapfunc(state, year, 'projections'),
      tableData: ranking,
      colGroups: getColGroups(state, key, position),
    },
  };
};
const actions = {
  goToView,
  clearSelectedPlayers,
};
class PlayerProjections extends PureComponent {
  static propTypes = {
    tableData: DataPT,
    hasLoaded: PT.bool.isRequired,
    selectedYear: PT.number.isRequired,
    selectedProfile: PT.number.isRequired,
    selectedPosition: PT.string.isRequired,
    selectedWeek: PT.number.isRequired,
    positions: FilterMenuOptionsType.isRequired,
    positionsCombined: FilterMenuOptionsType.isRequired,
    weeks: DropdownOptionsType,
    goToView: PT.func.isRequired,
    clearSelectedPlayers: PT.func.isRequired,
    colGroups: ColGroupsTypes,
    toolsLoaded: PT.bool.isRequired,
    loggedIn: PT.bool.isRequired,
    gciPageView: PT.func.isRequired,
    lastUpdatedAt: PT.string,
  }

  static defaultProps = {
    weeks: [],
    colGroups: [],
    tableData: [],
    loggedIn: false,
    lastUpdatedAt: null,
  }

  state = {
    showAnalysis: false,
    hideInjury: true,
    prevLogin: false,
    didFirst: false,
    isMobile: false,
  }

  componentWillMount() {
    this.props.clearSelectedPlayers();
    if (typeof(window) !== 'undefined')
      this.setState({ isMobile: window.innerWidth < 728 })
  }

  throttledHandleWindowResize = () => {
    this.setState({ isMobile: window.innerWidth < 728 })
  }

  handleChangeYear = (event, { value }) => {
    const { selectedYear, selectedProfile, selectedPosition } = this.props;

    if (selectedYear !== value) {
      this.props.goToView(
        PROJECTIONS_VIEW,
        {
          query: { year: value, formulaId: selectedProfile, position: selectedPosition },
          updateQuery: false,
        },
      );
    }
  }

  handleChangeProfile = (event, { value }) => {
    if (this.props.selectedProfile !== value) {
      this.props.goToView(PROJECTIONS_VIEW, { query: { formulaId: value } });
    }
  }

  handleChangePosition = (event, { value }) => {
    if (this.props.selectedPosition !== value) {
      if (this.shouldDisableToggle(value)) {
        if (this.state.showAnalysis) { this.setState(prevState => ({showAnalysis: false })); }
      }
      this.props.goToView(PROJECTIONS_VIEW, { query: { position: value } });
    }
  }

  handleChangeWeek = (event, { value }) => {
    if (this.props.selectedWeek !== value) {
      this.props.goToView(PROJECTIONS_VIEW, { query: { week: value } });
    }
  }

  toggleAnalysis = () => this.setState(prevState => ({ showAnalysis: !prevState.showAnalysis }));

  shouldDisableToggle = (pos) => {
    const disableThese = ['PK','DL','LB','DB','DL,LB,DB'];
    if (disableThese.includes(pos))
      return true;
    else
      return false;
  }

  setPageTitle = () => {
    document.title = pageTitle + ': ' + positionToTitle(this.props.selectedPosition, { capitalize: true, plural: true }) + ' - TheHuddle';
  }

  render() {
    const {
      tableData,
      positions,
      positionsCombined,
      weeks,
      selectedYear,
      selectedProfile,
      selectedPosition,
      selectedWeek,
      hasLoaded,
      colGroups,
      toolDescriptions,
      toolsLoaded,
      loggedIn,
      lastUpdatedAt,
    } = this.props;
    const { showAnalysis } = this.state;
    // for collapsed
    let updateAtString = 'Updated: Not available';
    if (lastUpdatedAt) {
      const lastUpdateDate = lastUpdatedAt.substring(0, lastUpdatedAt.indexOf(' '));
      const lastUpdateTime = lastUpdatedAt.substring(lastUpdatedAt.indexOf(' ') + 1);
      updateAtString = `Updated: ${lastUpdateDate} @ ${lastUpdateTime}`;
    }


    const wrapperClass = classNames(
      classes.tableWrapper,
      { [classes.collapsed]: this.props.collapsed },
    );

    if (colGroups[1]) {
      if (selectedWeek === 0) {
        colGroups[1].columns.splice(0, 0, 'bye');
        colGroups[1].fixedColumns.splice(0, 0, 'bye');
      } else {
        colGroups[1].columns.splice(0, 0, 'opponent_team_abbr');
        colGroups[1].fixedColumns.splice(0, 0, 'opponent_team_abbr');
      }

      if (selectedPosition.length >= 5) {
        colGroups[0].columns.splice(1, 0, 'Pos');
        colGroups[0].fixedColumns.splice(1, 0, 'Pos');
      }
    }
    let printLink = '';
    let downloadLink = '';
    if (hasLoaded) {
      printLink = '/fantasy-football-projections-print?year=' + selectedYear + '&formulaId=' + selectedProfile + '&position=' + selectedPosition + '&week=' + selectedWeek;
      downloadLink = '/api/RankingsCSV/' + selectedYear + '/' + selectedWeek + '/' + selectedPosition + '/' + selectedProfile + '/huddle_' + selectedYear + '_' + selectedWeek + '_' + selectedPosition + '_projections.csv';
    }

    // for testing, hide injury data and icon
    // this.setState({ hideInjury: selectedYear === 2018 && selectedWeek === 0});

    return (
      <div className={classes.wrapper}>
        <FiltersHeader
          title={pageTitle + `: ${positionToTitle(selectedPosition, { capitalize: true, plural: true })}`}
          description={toolsLoaded && toolDescriptions.tool_descriptions.projections.visible == 1 && (
            <ToolDescription
              descr={toolDescriptions.tool_descriptions.projections.text}
            />)}
          seasonType={selectedWeek === 0 ? 'preseasons' : 'seasons'}
          statType="projections"
          selectedYear={selectedYear}
          selectedProfile={selectedProfile}
          onChangeProfile={this.handleChangeProfile}
          onChangeYear={this.handleChangeYear}
          printLink={loggedIn ? printLink : null}
          downloadLink={loggedIn ? downloadLink : null}
        >

          <ButtonMenu
            choices={positions}
            label={'Position:'}
            activeItem={selectedPosition}
            onChange={this.handleChangePosition}
          />
          <ButtonMenu
            choices={positionsCombined}
            label={'Combined Positions:'}
            activeItem={selectedPosition}
            onChange={this.handleChangePosition}
          />
          <PrimaryDropdown
            choices={weeks}
            label={'Timeframe:'}
            activeItem={selectedWeek}
            onChange={this.handleChangeWeek}
          />
          {!this.shouldDisableToggle(selectedPosition) &&
            <FilterToggle
              label={'Include Analysis:'}
              checked={showAnalysis}
              valueOff={'NO'}
              valueOn={'YES'}
              onChange={this.toggleAnalysis}
            />
          }

        </FiltersHeader>

        <TableControls
          track
          compare
          injury={this.state.hideInjury ? false : true}
          hideInjury={this.state.hideInjury ? true : false}
          colGroups={colGroups}
          lastUpdatedAt={updateAtString}
        />
        {hasLoaded &&
          <DataTable
            className={wrapperClass}
            track
            compare
            injury={this.state.hideInjury ? false : true}
            selectedLeague={selectedProfile}
            showAnalysis={showAnalysis}
            showRookie
            colGroups={colGroups}
            showAt={true}
            data={tableData}
          />
        }
      </div>
    );
  }

  componentDidMount() {
    this.setPageTitle();
    gciPageView(pageTitle);
    this.setState({ didFirst: true });
    window.addEventListener('resize', this.throttledHandleWindowResize.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.throttledHandleWindowResize.bind(this));
  }

  componentDidUpdate(prevProps, prevState) {
    this.setPageTitle();
    if (this.state.didFirst && this.state.prevLogin !== prevProps.loggedIn) {
      this.setState({ prevLogin: prevProps.loggedIn });
      const { selectedYear, selectedWeek, selectedProfile, selectedPosition } = this.props;
      this.props.goToView(
        PROJECTIONS_VIEW, {
          query: { year: selectedYear, formulaId: selectedProfile, position: selectedPosition, week: selectedWeek },
          updateQuery: false,
        },
      );
    }
  }
}
export default connect(mapStateToProps, actions)(PlayerProjections);



// WEBPACK FOOTER //
// ./src/app/views/PlayerProjections/PlayerProjections.js